module.exports = __webpack_public_path__ + "static/img/hgsw42.366ac26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hgsw42.png
// module id = kfSM
// module chunks = 73